<h2>EDIZIONE 2019</h2>
<div id="istruzioni">
	<h3>Istruzioni</h3>
	<ul>
		<li>Le Cryptowars2019 si svolgono nella settimana 21--27 Ottobre 2019.</li>
		<li>Inizio iscrizione dei team: 1 Ottobre 2019.</li>
		<li>Fine iscrizione dei team: 20 Ottobre 2019.</li>
		<li>Inizio gara: 21 Ottobre 2019 ore 14:00 (Milano).</li>
		<li>Fine gara: 27 Ottobre 2019 ore 23:59 (Milano).</li>
		<li>Sono ammessi alla gara team composti da un massimo di 5 studenti.
			Con "studenti" intendiamo iscritti a: laurea, laurea triennale,
			laurea magistrale, dottorato di ricerca.</li>
		<li>Il team partecipante deve essere identificato con un unico indirizzo e-mail.
			Per iscriversi bisogna inviare una email a cryptowars19&#64;gmail.com
			avente come oggetto la parola ISCRIZIONE.
			Nel messaggio di posta elettronica devono comparire il nome
			dei partecipanti, il nome del team e
			l'indirizzo e-mail di riferimento.</li>
		<li>Dal 21 al 27 Ottobre, i partecipanti alle CRYPTOWARS possono inviare
			al più TRE soluzioni al medesimo quesito.
			Viene tenuta in considerazione solo l'ultima e-mail ricevuta. </li>
		<li> Le soluzioni devono essere inviate all’indirizzo cryptowars19&#64;gmail.com
			nel formato specificato nel file della challenge. Solitamente in formato .TXT. </li>
		<!--<li> Di seguito le <a href="../../../../assets/attivita/cryptowars/Cryptowars2019
				.zip">sfide</a> della gara. Nel 2019 abbiamo posto quesiti
			di varia natura, i quali spaziavano dalla rottura di alcune chiavi RSA
			ad alcuni cifrari pensati ad hoc, come Makwa. Abbiamo inoltre posto alcuni
			quesiti legati al mondo delle curve ellittiche. </li>
		-->
	</ul>
</div>
<hr>
<div id="FAQ">
	<h3>FAQ</h3>
	<ul>
		<li><i>Devo personalmente implementare del codice per risolvere i quesiti? </i><br>
			Non è richiesto di inviare il codice usato, quindi una via semplice è quella di
			cercare del codice già implementato. Resta il fatto che, siccome la gara ha soprattutto
			lo scopo di portare alla comprensione profonda di problemi crittografici, si consiglia
			di lavorare in maniera autonoma al proprio codice e alla sua ottimizzazione.<br>
		</li>
		<li><i>Devo pensare e implementare nuovi attacchi?</i><br>
			Non necessariamente. Esistono molti attacchi noti in letteratura, quindi cercane uno che
			ti sembra semplice da capire, implementalo e mandalo in esecuzione!</li>
	</ul>
</div>
<hr>
<div id="news">
	<h3>News</h3>
	<ul>
		<li>[29/10/2019] I risultati delle cryptowars 2019 sono stati
			pubblicati.</li>
		<li>[27/10/2019] Ore 23:59, abbiamo chiuso la competizione.</li>
		<li>[21/10/2019] Ore 14, abbiamo dato il via alla competizione.</li>
		<li>[21/10/2019] I team iscritti alla competizione sono 13 + 1.
			Un team ha partecipato fuori competizione.</li>
		<li>[01/10/2019] Aperte le iscrizioni alla competizione CRYPTOWARS 2019. </li>
	</ul>
</div>
<hr>
<div id="classificaFinale">
	<h3>Final Ranking</h3>
	<p align="justify">Note:</p>
	<ul align="justify">
		<li> È possibile interagire con la legenda del grafico superiore, cliccando sul
			colore relativo ad ogni team per gestirne la visualizzazione.</li>
		<li> Il grafico superiore è stato realizzato tenendo traccia delle soluzioni
			inviate durante la gara:<br>
			- in caso di soluzione corretta, il punteggio accumulato (posto inizialmente a 0)
			è stato incrementato;<br>
			- in caso di soluzione errata, il punteggio accumulato è rimasto invariato;<br>
			- in caso di soluzione errata (avendo già consegnato precedentemente una
			soluzione corretta), il punteggio accumulato è stato decrementato.</li>
		<li> Per completezza, sono stati riportati in colore più chiaro i risultati dei
			team che non hanno rispettato il protocollo di iscrizione.</li>
	</ul>
	<p align="justify"> Ecco la classifica finale: </p>
	<table class="tg" align="center">
		<tr>
			<th class="tg-7btt">PODIO</th>
			<th class="tg-7btt">TEAM</th>
		</tr>
		<tr>
			<td class="tg-uys7">#1</td>
			<td class="tg-0pky">pwnthem0le</td>
		</tr>
		<tr>
			<td class="tg-c3ow">#2</td>
			<td class="tg-0pky">Critto Tanto</td>
		</tr>
		<tr>
			<td class="tg-c3ow">#3</td>
			<td class="tg-0pky">Canederlo Trentuno</td>
		</tr>
	</table>
</div>